const getRangeArray = ({ min = 0, max }) => {
  const length = max - min + 1

  return [...Array(length).keys()].map(value => value + min)
}

export default getRangeArray
